


















import {Prop, Watch} from "vue-property-decorator";
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Timeout, WatchObjectProperties} from '@/shared/decorator';

import storeLogement, {LogementFilter} from '@/stores/modules/logement';

import InputNumberFilter from '@/components/Input/NumberFilter.vue';
import InputTva from '@/components/Input/Tva.vue';
import {ArrayHelper} from "@/shared/utils";

import InputDateFilter from '@/components/Input/DateFilter.vue';

@Component({
	components: {
		InputDateFilter,
		InputNumberFilter,
		InputTva,
	}
})
export default class CrudLogementFilter extends Vue {

	@Prop({ type: Boolean, default: false}) public reduce: boolean;

	@Stored(() => storeLogement) private page!: number;
	@Stored(() => storeLogement) private filters!: LogementFilter;

	@WatchObjectProperties('filters', LogementFilter)
	@Timeout()
	private filtersWatcher(): void {
		this.page = 0;
		storeLogement.dispatch('getC', { filters: true });
	}

	public mounted(): void {
		this.filters = new LogementFilter();
	}

}
